







































// require('./lib/ui/root.js');

import chat from "../../components/chat.vue"
import ripple from "../../components/ripple.vue"
import inlineTextEdit from "../../components/inlineTextEdit.vue"
import {frontendClient} from "../../lib/client"
import {HTTPPostAPI} from "../../lib/httpapi"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval, clearInterval } from "timers";
import { fromNode } from "bluebird";

@Component({
    components : {
        chat,
        ripple,
        inlineTextEdit
    },
})
export default class ChatRoute extends Vue{
    connectToUser: HTTPPostAPI["messages/listusers"]["result"]["users"][0] | false = false;

    users: HTTPPostAPI["messages/listusers"]["result"]["users"] = [];
    openMore:boolean = false;

    msgCb: any;
    loaded:boolean = false;

    async mounted(){
        this.$emit('scope','chat');

        let int = null;
        new Promise((resolve, reject) => {
            int = setInterval(() => {
                if(this.$route.params && frontendClient){
                    clearInterval(int);
                    int = null;
                    resolve();
                }
            },50)
        }).then(async () => {
            await this.loadUserList();

            this.msgCb = (entry) => {
                for(let user of this.users) {
                    if(entry.fromUserID === user.userID) {          
                        user.lastMessage.fromName = entry.fromUsername,
                        user.lastMessage.msgContent = entry.body;
                        break;
                    }
                }
            };
            frontendClient.wsClient.on("newmessage",this.msgCb);

            if(!this.loaded){
                if(!this.$route.params.connectedToID){
                    this.connectToUser = this.users[0];
                }else{
                    for(let i = 0; i<this.users.length;i++){
                        if(this.users[i].userID == this.$route.params.connectedToID){
                            this.connectToUser = this.users[i];
                            break;
                        }
                    }
                }
                this.loaded = true;
            }
        }).catch((e) => {
            frontendClient.giveError(e);
        })
    }

    async loadUserList() {
        this.users = (await frontendClient.postEx("messages/listusers",{})).users;
    }

    selectUser(user: HTTPPostAPI["messages/listusers"]["result"]["users"][0]) {
        this.connectToUser = user;
    }

    searchVal:string = null;
    updateSearch(newVal){
        this.searchVal = newVal;
        this.searchVal = this.searchVal?this.searchVal.toLowerCase():'';
    }

    beforeDestroy() {
        frontendClient.wsClient.removeListener("newmessage",this.msgCb);
    }
}
